import React from 'react';

export default ({handleSortClick, order, sortedBy}) => {
  function createClasses(key) {
    if (sortedBy === key) return `${order ? 'asc' : 'desc'} active`;
    return '';
  }

  return (
    <div className='list-scene__table-header'>
      <div className='list-scene__table-header-element _width_pc_8' />

      <div
        className={`list-scene__table-header-element ${createClasses('id')} _width_pc_12`}
        onClick={handleSortClick('id')}
      >
        <div>ID</div>
        <div className='list-scene__table-header-element-sort-arrow' />
      </div>

      <div
        className={`list-scene__table-header-element ${createClasses('name')} _width_pc_50`}
        onClick={handleSortClick('name')}
      >
        <div>Name</div>
        <div className='list-scene__table-header-element-sort-arrow' />
      </div>

      <div
        className={`list-scene__table-header-element ${createClasses('status')} _width_pc_12`}
        onClick={handleSortClick('status')}
      >
        <div>Status</div>
        <div className='list-scene__table-header-element-sort-arrow' />
      </div>

      <div className='list-scene__table-header-element _width_pc_28' />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/app/Scenes/TrailerManufacturer/List/TableHeader.jsx